import React, { memo, useEffect, useState } from 'react';
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../models/stores/actions';
import { initRootRemSize, handleScroll } from '../utils';
import SlideShowViwer from '../components/SlideShowViwer';

import Header from './Header';
import Footer from './Footer';



const Layouts = memo(() => {
  const [ scrollNum, setScrollNum ] = useState(0);
  const [ getCHSTopVal, setCHSTopVal ] = useState(0);
  const dispatch = useDispatch();
  const { selectScrollNum, handleRecReSize } = actions;
  const viewrSliceReducer = useSelector(({viewrSliceReducer}) => viewrSliceReducer);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleRecSize = () => {
    initRootRemSize({
      cab:(cwSize) => {
        const screenHeightVal = document.documentElement.clientHeight;
        dispatch(handleRecReSize({value: cwSize, screenHeight: screenHeightVal}));
      }
    });
    window.onresize = () => {
      const screenHeightVal = document.documentElement.clientHeight;
      initRootRemSize({
        cab:(cwSize) => {
          dispatch(handleRecReSize({value: cwSize, screenHeight: screenHeightVal }));
        }
      });
    }
  }


  useEffect(() => {
    handleRecSize();

    handleScroll({
      cab: ({scrollVal, cHSTopVal}) => {
        setScrollNum(scrollVal);
        setCHSTopVal(cHSTopVal);
      }
    });

    dispatch(selectScrollNum({value: scrollNum, cshVal: getCHSTopVal}));

    return () => {
      handleRecSize();
      handleScroll({
        cab: ({scrollVal, cHSTopVal}) => {
          setScrollNum(scrollVal);
          setCHSTopVal(cHSTopVal);
        }
      });
      dispatch(selectScrollNum({value: scrollNum, cshVal: getCHSTopVal}));
    }
  }, [dispatch, getCHSTopVal, handleRecSize, scrollNum, selectScrollNum]);


  // 打开弹窗后修改页面不让滚动
  useEffect(() => {
    const { visible} = viewrSliceReducer;
    const isFlag = visible;

    if(isFlag){
      document.documentElement.style.overflowX = 'hidden';
      document.documentElement.style.overflowY = 'hidden';
    }else{
      document.documentElement.style.overflowX = 'hidden';
      document.documentElement.style.overflowY = 'scroll';
    }
  }, [viewrSliceReducer]);

  const desktopMobile = () => {
    const { visible} = viewrSliceReducer;
    const styles = {
      transition: 'all 1s',
      transform: `translate(0px, 0px)`,
    };

    return (
      <>
        <Header 
          scrollNum={scrollNum}
          config={styles}
        />

        <div 
          className='main'
          style={styles}
        >
          <Outlet />
        </div>
        <Footer config={styles} />
        {visible ? <SlideShowViwer /> : null}
      </>
   );
  }

  return desktopMobile();
});

export default Layouts;